import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateShowFolderDocument } from './update.generated';

export const useUpdateShowFolder = (options: ApiOptions<typeof UpdateShowFolderDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(UpdateShowFolderDocument, {
    ...useNotifications(UpdateShowFolderDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.show_folders.update_success'),
    }),
    ...options,
  });
};
